import { createPortal } from "react-dom";
import { Segmented, Table, Button } from "antd";
import { TeamOutlined, FileTextOutlined, FilterOutlined } from "@ant-design/icons";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import {
	loadAllProject,
	loadAllProjectByStatus,
} from "../../redux/rtk/features/projectManagement/project/project/project";
import { loadProjectSiteDetails } from "../../redux/rtk/features/projectManagement/project/projectSite/projectSiteDetails";
import { loadAllStaff } from "../../redux/rtk/features/user/userSlice";
// import KanbanBtn from "../Buttons/KanbanBtn";
import UpdateBtn from "../Buttons/UpdateBtn";
import dayjs from "dayjs";

import { CSVLink } from "react-csv";
// import MilestoneBtn from "../Buttons/MilestoneBtn";
import UpdateStatusBtn from "../Buttons/UpdateStatusBtn";
import { GreenLinkBtn } from "../UI/AllLinkBtn";
import BtnAllSvg from "../UI/Button/btnAllSvg";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";
import TaskAddSinglePopup from "../UI/PopUp/ProjectManagemnet/TaskAddSinglePopup";
import FilterPanel from "../hiring/FilterPanel";
import "../hiring/FilterPanel.css";

const normalizeProjectRecord = (record, index) => {
	const projectId = record?.ProjectId ?? record?.projectId ?? record?.id ?? index;
	return {
		...record,
		ProjectId: projectId,
		ProjectName: record?.ProjectName ?? record?.projectName ?? "",
		ProjectSiteName: record?.ProjectSiteName ?? record?.projectSiteName ?? "",
		ProjectManagerName: record?.ProjectManagerName ?? record?.ProjectManager?.EmployeeName ?? "",
		StartDate: record?.StartDate ?? record?.startDate ?? null,
		EndDate: record?.EndDate ?? record?.endDate ?? null,
		TotalBudget: record?.TotalBudget ?? record?.totalBudget ?? null,
		DataStatus: record?.DataStatus ?? record?.dataStatus ?? null,
		key: projectId ?? index,
		serial: index + 1,
	};
};

const addKeys = (arr = []) =>
	Array.isArray(arr) ? arr.map((item, index) => normalizeProjectRecord(item, index)) : [];

const Project = (props) => {
	const { onEditProject, filterOpen: filterOpenProp, onFilterClose } = props || {};
	const dispatch = useDispatch();
	const isLogged = Boolean(localStorage.getItem("isLogged"));
	const navigate = useNavigate();

	const { loading, list } = useSelector((state) => state?.project);
	const userList = useSelector((state) => state?.users?.list) || [];
	const projectSiteList = useSelector((state) => state?.projectSiteDetails?.list) || [];
	const [columnsToShow, setColumnsToShow] = useState([]);
	const [status, setStatus] = useState("all");
	const [filterOpenLocal, setFilterOpenLocal] = useState(false);
	const filterOpen = filterOpenProp !== undefined ? filterOpenProp : filterOpenLocal;
	const handleFilterClose = () => {
		if (onFilterClose) onFilterClose();
		else setFilterOpenLocal(false);
	};
	const showFilterButton = onFilterClose == null;
	const [filterDateRange, setFilterDateRange] = useState([null, null]);
	const [filterProjectName, setFilterProjectName] = useState("");
	const [filterProjectManager, setFilterProjectManager] = useState("");
	const [filterProjectSite, setFilterProjectSite] = useState("");

	const columns = useMemo(() => [
		{
			id: 1,
			title: "S.No",
			dataIndex: "serial",
			key: "serial",
			width: 60,
		},
		{
			id: 2,
			title: "Project Name",
			dataIndex: "ProjectName",
			key: "ProjectName",
			width: 180,
			render: (value) => (
				<div className='font-semibold'>{(value || "-").toString().toUpperCase()}</div>
			),
		},
		{
			id: 3,
			title: "Project Manager",
			dataIndex: "ProjectManagerName",
			key: "ProjectManagerName",
			width: 140,
			render: (_, record) => record?.ProjectManagerName || record?.EmployeeName || "-",
		},
		{
			id: 4,
			title: "Project Site",
			dataIndex: "ProjectSiteName",
			key: "ProjectSiteName",
			width: 160,
			render: (value) => value || "-",
		},
		{
			id: 5,
			title: "Start Date",
			dataIndex: "StartDate",
			key: "StartDate",
			width: 110,
			render: (value) => (value ? dayjs(value).format("YYYY-MM-DD") : "-"),
		},
		{
			id: 6,
			title: "End Date",
			dataIndex: "EndDate",
			key: "EndDate",
			width: 110,
			render: (value) => (value ? dayjs(value).format("YYYY-MM-DD") : "-"),
		},
		{
			id: 7,
			title: "Description",
			dataIndex: "ProjectDescription",
			key: "ProjectDescription",
			width: 120,
			render: (value) => value || "-",
		},
		{
			id: 8,
			title: "Total Budget",
			dataIndex: "TotalBudget",
			key: "TotalBudget",
			width: 120,
			render: (value) => (value !== undefined && value !== null ? Number(value).toLocaleString() : "-"),
		},
		// {
		// 	id: 9,
		// 	title: "Status",
		// 	dataIndex: "DataStatus",
		// 	key: "DataStatus",
		// 	render: (value) => {
		// 		const statusValue = Number(value);
		// 		if (statusValue === 1) return "Active";
		// 		if (statusValue === 0) return "Inactive";
		// 		if (statusValue === 2) return "Deleted";
		// 		return value ?? "-";
		// 	},
		// },
		{
			id: 9,
			title: "My Project",
			key: "myProject",
			width: 100,
			render: (_, record) => {
				const projectId = record?.ProjectId ?? record?.id;
				return (
					<Button
						type="link"
						icon={<TeamOutlined />}
						onClick={() => navigate("/admin/team", { state: { projectId } })}
						title="View Team"
					/>
				);
			},
		},
		{
			id: 10,
			title: "WBS",
			key: "wbs",
			width: 80,
			render: (_, record) => {
				const projectId = record?.ProjectId ?? record?.id;
				return (
					<Button
						type="link"
						icon={<FileTextOutlined />}
						onClick={() => navigate("/admin/project/wbs", { state: { projectId } })}
						title="Manage WBS"
					/>
				);
			},
		},
		// {
		// 	id: 11,
		// 	title: "Kanban Board",
		// 	key: "board",
		// 	render: (_, record) => {
		// 		const projectId = record?.ProjectId ?? record?.id;
		// 		return (
		// 			<div className='flex justify-start'>
		// 				<KanbanBtn path={`/admin/kanban/${projectId}/`} />
		// 			</div>
		// 		);
		// 	},
		// },
		// {
		// 	id: 12,
		// 	title: "Milestone",
		// 	key: "milestone",
		// 	render: (_, record) => {
		// 		const projectId = record?.ProjectId ?? record?.id;
		// 		return (
		// 			<div className='flex justify-start'>
		// 				<MilestoneBtn path={`/admin/project/${projectId}/milestone/`} />
		// 			</div>
		// 		);
		// 	},
		// },
		
		{
			id: 14,
			title: "Action",
			key: "action",
			width: 120,
			render: (_, record) => {
				const projectId = record?.ProjectId ?? record?.id;
				return (
					<div className='flex justify-start'>
						{typeof onEditProject === "function" ? (
							<Button type="link" onClick={() => onEditProject(record)}>
								Edit
							</Button>
						) : (
							<UpdateBtn path={`/admin/project/update/${projectId}`} />
						)}
						<UpdateStatusBtn path={`/admin/project/update/${projectId}/status`} />
					</div>
				);
			},
		},
	], [navigate, onEditProject]);

	useEffect(() => {
		dispatch(loadAllProject());
	}, [dispatch]);

	useEffect(() => {
		dispatch(loadAllStaff());
		dispatch(loadProjectSiteDetails());
	}, [dispatch]);

	useEffect(() => {
		setColumnsToShow(columns);
	}, [columns]);

	const projectManagerOptions = useMemo(() => {
		const options = [{ value: "", label: "Select Project Manager" }];
		(userList || []).forEach((u) => {
			const id = u?.EmployeeId ?? u?.employeeId ?? u?.id;
			const name =
				u?.EmployeeName ??
				u?.employeeName ??
				(u?.firstName || u?.lastName ? [u.firstName, u.lastName].filter(Boolean).join(" ") : null) ??
				u?.name ??
				u?.UserName ??
				"—";
			if (id != null && id !== "") options.push({ value: id, label: name });
		});
		return options;
	}, [userList]);

	const projectSiteOptions = useMemo(() => {
		const options = [{ value: "", label: "Select Project Site" }];
		(projectSiteList || []).forEach((site) => {
			const id = site?.ProjectSiteId ?? site?.id;
			const name = site?.ProjectSiteName ?? site?.projectSiteName ?? "—";
			if (id != null && id !== "") options.push({ value: id, label: name });
		});
		return options;
	}, [projectSiteList]);

	const filteredList = useMemo(() => {
		const raw = list || [];
		let result = raw;
		if (filterProjectName && filterProjectName.trim()) {
			const search = filterProjectName.trim().toLowerCase();
			result = result.filter((item) => {
				const name = (item?.ProjectName ?? item?.projectName ?? "").toString().toLowerCase();
				return name.includes(search);
			});
		}
		if (filterProjectManager) {
			const managerId = (item) => item?.ProjectManagerId ?? item?.projectManagerId ?? item?.ManagerId;
			result = result.filter((item) => Number(managerId(item)) === Number(filterProjectManager));
		}
		if (filterProjectSite) {
			const siteId = (item) => item?.ProjectSiteId ?? item?.projectSiteId;
			result = result.filter((item) => Number(siteId(item)) === Number(filterProjectSite));
		}
		if (filterDateRange && (filterDateRange[0] || filterDateRange[1])) {
			const startD = filterDateRange[0] ? dayjs(filterDateRange[0]) : null;
			const endD = filterDateRange[1] ? dayjs(filterDateRange[1]) : null;
			result = result.filter((item) => {
				const pStart = item?.StartDate ?? item?.startDate;
				const pEnd = item?.EndDate ?? item?.endDate;
				if (!pStart && !pEnd) return true;
				const projStart = pStart ? dayjs(pStart) : null;
				const projEnd = pEnd ? dayjs(pEnd) : null;
				if (startD && projEnd && projEnd.isBefore(startD)) return false;
				if (endD && projStart && projStart.isAfter(endD)) return false;
				return true;
			});
		}
		return result;
	}, [list, filterProjectName, filterProjectManager, filterProjectSite, filterDateRange]);

	const handleClearFilters = () => {
		setFilterDateRange([null, null]);
		setFilterProjectName("");
		setFilterProjectManager("");
		setFilterProjectSite("");
	};


	if (!isLogged) {
		return <Navigate to={"/admin/auth/login"} replace={true} />;
	}
	//make a onChange function
	const onChange = (value) => {
		// console.log(value);
		setStatus(value);
		dispatch(loadAllProjectByStatus(value));
	};
	const onAllClick = () => {
		setStatus("all");
		dispatch(loadAllProject());
	};

	return (
		<div className="project-list-page-container">
			<div className='ant-card p-2 rounded mt-0 project-list-container'>
				<div className='flex my-2 justify-between'>
				{/* <div className='w-50'>
					<h4 className='text-2xl mb-2'>Project List</h4>
				</div> */}
				{list && (
					<div className='flex justify-end mr-4 align-items-center flex-wrap'>
						<div className="filter-panel-wrap" style={{ position: "relative" }}>
							{showFilterButton && (
								<button
									type="button"
									className="filter-panel-trigger"
									onClick={() => setFilterOpenLocal((o) => !o)}
									aria-label="Filters"
									style={{ marginRight: 8 }}
								>
									<FilterOutlined style={{ fontSize: 16 }} />
								</button>
							)}
							{/* When filter is opened from parent (AddProject), render panel in portal so it appears above table */}
							{onFilterClose && filterOpen ? (
								createPortal(
									<div
										style={{
											position: "fixed",
											top: 80,
											right: 24,
											zIndex: 1050,
											minWidth: 280,
											maxWidth: 320,
										}}
									>
										<FilterPanel
											open={true}
											onClose={handleFilterClose}
											search={{
												placeholder: "Project Name",
												value: filterProjectName,
												onChange: setFilterProjectName,
											}}
											dateRange={filterDateRange}
											onDateRangeChange={setFilterDateRange}
											filters={[
												{
													key: "projectManager",
													label: "Project Manager",
													placeholder: "Select Project Manager",
													value: filterProjectManager,
													onChange: setFilterProjectManager,
													options: projectManagerOptions,
													showSearch: true,
												},
												{
													key: "projectSite",
													label: "Project Site",
													placeholder: "Select Project Site",
													value: filterProjectSite,
													onChange: setFilterProjectSite,
													options: projectSiteOptions,
													showSearch: true,
												},
											]}
											onClearAll={handleClearFilters}
										/>
									</div>,
									document.body
								)
							) : (
								<FilterPanel
									open={filterOpen}
									onClose={handleFilterClose}
									search={{
										placeholder: "Project Name",
										value: filterProjectName,
										onChange: setFilterProjectName,
									}}
									dateRange={filterDateRange}
									onDateRangeChange={setFilterDateRange}
									filters={[
										{
											key: "projectManager",
											label: "Project Manager",
											placeholder: "Select Project Manager",
											value: filterProjectManager,
											onChange: setFilterProjectManager,
											options: projectManagerOptions,
											showSearch: true,
										},
										{
											key: "projectSite",
											label: "Project Site",
											placeholder: "Select Project Site",
											value: filterProjectSite,
											onChange: setFilterProjectSite,
											options: projectSiteOptions,
											showSearch: true,
										},
									]}
									onClearAll={handleClearFilters}
								/>
							)}
						</div>
						<div className='mt-0'>
							<CsvLinkBtn>
								<CSVLink
									data={filteredList}
									className='btn btn-dark btn-sm'
									style={{ marginTop: "5px" }}
									filename='project_list'>
									Download CSV
								</CSVLink>
							</CsvLinkBtn>
						</div>

						<div className='ml-2 mt-0.5'>
							<GreenLinkBtn>
								<button onClick={onAllClick}>
									<BtnAllSvg size={15} title={"ALL"} />
								</button>
							</GreenLinkBtn>
						</div>
						<div>
							<Segmented
								className='text-center rounded text-red-500'
								size='middle'
								options={[
									{
										label: (
											<span>
												<i className='bi bi-person-lines-fill'></i> PROGRESS
											</span>
										),
										value: "PROGRESS",
									},
									{
										label: (
											<span>
												<i className='bi bi-person-dash-fill'></i> COMPLETE
											</span>
										),
										value: "COMPLETE",
									},
									{
										label: (
											<span>
												<i className='bi bi-person-dash-fill'></i> ONHOLD
											</span>
										),
										value: "ONHOLD",
									},
									{
										label: (
											<span>
												<i className='bi bi-person-dash-fill'></i> DELETED
											</span>
										),
										value: "DELETED",
									},
								]}
								value={status}
								onChange={onChange}
							/>
						</div>
					</div>
				)}
				</div>
				{loading ? (
					<div className="text-center py-8">
						<div className="ant-spin ant-spin-lg ant-spin-spinning">
							<span className="ant-spin-dot ant-spin-dot-spin">
								<i className="ant-spin-dot-item"></i>
								<i className="ant-spin-dot-item"></i>
								<i className="ant-spin-dot-item"></i>
								<i className="ant-spin-dot-item"></i>
							</span>
						</div>
						<p className="mt-4 text-gray-600">Loading projects...</p>
					</div>
				) : !list || list.length === 0 ? (
					<div className="text-center py-8">
						<p className="text-gray-600">No projects found.</p>
					</div>
				) : filteredList.length === 0 ? (
					<div className="text-center py-8">
						<p className="text-gray-600">No projects match the selected filters.</p>
					</div>
				) : (
					<Table
						scroll={{ x: true, y: "100%" }}
						pagination={{
							defaultPageSize: 20,
						}}
						columns={columnsToShow}
						dataSource={addKeys(filteredList)}
						className="get-all-user-table"
					/>
				)}
			</div>
		</div>
	);
};

export default Project;
